import {
  brandIcon,
  brandIconNegative,
  brandIconTransparent,
  brandLogo,
  brandLogoNegative,
  brandLogoTransparent,
} from './customLogos';
import { LogoDefinition } from './types';

const logos: LogoDefinition[] = [
  brandIcon,
  brandIconNegative,
  brandIconTransparent,
  brandLogo,
  brandLogoNegative,
  brandLogoTransparent,
];

enum Logos {
  brandIcon = 'brandIcon',
  brandIconNegative = 'brandIconNegative',
  brandIconTransparent = 'brandIconTransparent',
  brandLogo = 'brandLogo',
  brandLogoNegative = 'brandLogoNegative',
  brandLogoTransparent = 'brandLogoTransparent',
}

export { logos, Logos };
